import { LayoutPanelTop } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";

const ppcHeroSection: ServiceSection = {
  type: SECTION_TYPES.PPC_HERO,
  content: {
    header: "Content will go here...",
    subheader: "This is a lovely place for a subtitle, coming soon...",
    accolades: [
      {
        description: "Family-Owned",
      },
      {
        description: "Certified",
      },
      {
        description: "Satisfaction Guaranteed",
      },
    ],
    bgImage: {
      alt: "",
      providerId: "",
      source: "",
      url: "https://images.unsplash.com/photo-1592595896551-12b371d546d5?q=60&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3",
    },
  },
  meta: {
    displayName: "Hero PPC",
    displayDescription: "Introduce your business to your customers.",
    displayIcon: LayoutPanelTop,
  },
};

export default ppcHeroSection;
